import React,{ useContext } from 'react'
import './Toggle.css'
import SunLineIcon from 'remixicon-react/SunLineIcon'
import MoonLineIcon from 'remixicon-react/MoonLineIcon'
import {themeContext} from '../../Context'

const Toggle = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    const changeTheme = ()=>{
        theme.dispatch({type:'toggle'})
    }
    return (
        <div className={darkMode?'toggle_dark':'toggle_light'} onClick={changeTheme} >
            <SunLineIcon style={{width:'20px'}} />
            <MoonLineIcon style={{width:'20px'}} />
            <div className={darkMode?'t-button_dark':'t-button_light'} style={!darkMode ? {left:'2px'} : {right:'2px'} }>
            </div>
        </div>
    )
}

export default Toggle